import React, { FunctionComponent, useCallback } from 'react';
import { Table, Typography } from 'antd';
import { useStore } from 'effector-react';
import moment from 'moment';
import { FULL_TIME_FORMAT } from '@config/format';
import push, { getList } from '@stores/push';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import IPush from '@interfaces/IPush';
import useTranslate from '@hooks/useTranslate';
import componentContent from './PushTable.content.json';
import { pageSizeOptions } from '@constants/pagination';
import useScrollTopPage from '@hooks/useScrollTopPage';

interface PushTableProps {}

const PushTable: FunctionComponent<PushTableProps> = () => {
  const { list, preloaders, pagination } = useStore(push);
  const content = useTranslate(componentContent);

  const onChange = useCallback((pagination: TablePaginationConfig) => {
    localStorage.setItem('pushPageSize', `${pagination.pageSize}`);
    getList({
      pagination,
    });
  }, []);

  useScrollTopPage(pagination);

  const shortName = (name: string) => {
    if (name.length < 150) return name;
    return name.substring(0, 150) + '...';
  };

  const columns: ColumnsType<IPush> = [
    {
      dataIndex: 'id',
      title: 'id',
      render: (id: string) => id && <Typography.Text>{id}</Typography.Text>,
    },
    {
      dataIndex: 'name',
      title: content.name,
      render: (name: string) => name && <Typography.Text>{shortName(name)}</Typography.Text>,
    },
    {
      dataIndex: 'createdAt',
      title: content.date,
      render: (createdAt: string) =>
        createdAt && (
          <Typography.Text>{moment(createdAt).format(FULL_TIME_FORMAT)}</Typography.Text>
        ),
    },
  ];

  return (
    <div>
      <Table
        onChange={onChange}
        dataSource={list}
        columns={columns}
        loading={!!preloaders.getList}
        rowKey='id'
        pagination={{
          ...pagination,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions,
          position: ['topRight', 'bottomRight'],
        }}
      />
    </div>
  );
};

export default PushTable;
